import { render, staticRenderFns } from "./okxActivity.vue?vue&type=template&id=19c94fd7&scoped=true&"
import script from "./okxActivity.vue?vue&type=script&lang=js&"
export * from "./okxActivity.vue?vue&type=script&lang=js&"
import style0 from "./okxActivity.vue?vue&type=style&index=0&id=19c94fd7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c94fd7",
  null
  
)

export default component.exports